import React from 'react';

const Oklahoma = () => (
  <svg
    width="117"
    height="60"
    viewBox="0 0 117 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.8"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M106.149 54.0559C104.502 53.6052 105.445 55.7457 104.101 55.5908C102.488 55.8372 102.101 54.8585 101.031 54.5699C98.736 54.6191 97.511 57.1891 95.9129 55.0838C94.2022 56.0977 92.4351 57.0623 90.7947 58.1537C89.1825 57.5481 87.9505 56.5624 86.6974 55.5908C85.4935 54.3375 85.7469 56.3582 84.1348 56.1048C83.9728 54.9008 82.5507 54.9571 82.0861 54.0559C81.1357 55.3232 79.1222 55.5274 79.5235 58.1537C77.9183 57.8016 78.8546 56.7877 79.0095 55.5908C77.5381 55.4852 76.4117 55.7175 75.94 56.6117C74.7291 55.7738 74.004 54.4572 72.3566 54.0488C70.7022 52.6477 70.9063 56.3864 68.2592 55.5837C69.1252 52.4928 65.1475 54.2601 66.2106 50.979C64.0774 50.8945 61.9372 50.803 61.0924 51.9999C57.5301 50.8734 54.0522 49.5849 50.856 49.437C51.5741 46.501 48.9763 46.8812 48.8073 44.8323C47.7654 47.1135 47.1036 45.8532 45.7378 45.8532C45.414 45.8532 45.1113 46.3461 45.2239 46.3672C43.0344 46.0081 42.1755 43.2129 40.1057 42.7834C40.2254 32.1517 40.676 21.8508 41.1265 11.55C38.0078 8.62102 32.9459 10.4024 28.3276 10.0151C20.5341 9.36032 8.64335 8.45908 0.300781 8.09295C0.814711 4.76261 0.814704 3.10095 1.19487 0.798584C37.0925 2.78411 74.6306 3.12912 112.795 2.84748C111.929 12.5709 115.217 20.5764 115.865 29.4691C116.555 38.9391 115.358 48.3457 115.865 59.1605C111.803 58.2945 109.529 55.6189 106.149 54.0559Z"
      fill="#FC374D"
    />
  </svg>
);

export default Oklahoma;
